import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import {
  CreateDataRetentionPolicyDetailDto,
  DataRetentionPolicyDto,
  UpdateDataRetentionPolicyDetailDto,
} from "../dto/DataRetentionPolicyDto";

import { OrganizationPublicId, UUIDString } from "../Types";

export class DataRetentionPolicyController {
  constructor(private axios: AxiosInstance) {}

  public getDataRetention = async (
    organizationId: OrganizationPublicId,
  ): Promise<DataRetentionPolicyDto> => {
    const url = Helpers.organization.dataRetention.root(organizationId);
    const response = await this.axios.get<DataRetentionPolicyDto>(url);
    return response.data;
  };

  public updateDataRetentionCategory = async (
    organizationId: OrganizationPublicId,
    id: UUIDString,
    dto: UpdateDataRetentionPolicyDetailDto,
  ): Promise<void> => {
    const url = Helpers.organization.dataRetention.category(organizationId, id);
    await this.axios.put<void>(url, dto);
  };

  public createDataRetentionCategory = async (
    organizationId: OrganizationPublicId,
    dto: CreateDataRetentionPolicyDetailDto,
  ): Promise<void> => {
    const url = Helpers.organization.dataRetention.root(organizationId);
    await this.axios.post<void>(url, dto);
  };

  public removeDataRetentionCategory = async (
    organizationId: OrganizationPublicId,
    id: UUIDString,
  ): Promise<void> => {
    const url = Helpers.organization.dataRetention.category(organizationId, id);
    await this.axios.delete<void>(url);
  };

  public manageAutomaticDataRetentionPolicy = async (
    organizationId: OrganizationPublicId,
  ): Promise<void> => {
    const url = Helpers.organization.dataRetention.automatic(organizationId);
    await this.axios.post<void>(url);
  };
}
